import {Request} from '../../request.abstract';
import {Http} from '@angular/http';
import {Settings} from '../../settings.model';
import {StatisticsEndpoint} from './statistics/api.service';
import {PlatformsEndpoint} from "./platforms/api.service";

export class ProxyEndpoint extends Request {
    protected messagecentralId: number;

    constructor(http: Http, settings: Settings, messagecentralId: number) {
        super(http, settings);
        this.messagecentralId = messagecentralId;
    }

    statistics(): StatisticsEndpoint {
        return new StatisticsEndpoint(this.http, this.settings, this.messagecentralId);
    }

    platforms(): PlatformsEndpoint {
        return new PlatformsEndpoint(this.http, this.settings, this.messagecentralId);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/messagecentrals/proxy/api.service.ts